import { selectCurrentPromoLoading } from '@simplisafe/ss-ecomm-data/redux/select'
import { useSelector } from 'react-redux'

export const useIsCurrentPromoLoading = (): boolean => {
  return useSelector(selectCurrentPromoLoading)
}
